import { TCountry, TEntity, TLanguage, TUserType } from '../types/app-context/components/utils'
import { getPrivacyCenterComponentsRemote } from './get-privacy-center-content'
import { getPrivacyCenterComponentsFromLocal } from './get-privacy-center-content-local'
import { getPrivacyCenterEndpointsRemote } from './get-privacy-center-endpoints'

const getPrivacyCenter = async ({
  userAccountType,
  userCountry,
  userSelectedEntity,
  userLanguage,
}: {
  userAccountType: TUserType
  userCountry: TCountry
  userSelectedEntity: TEntity
  userLanguage: TLanguage
}) => {
  const [privacyCenterComponents, privacyCenterEndpoints] = await Promise.all([
    getPrivacyCenterComponentsRemote({
      accountType: userAccountType,
      country: userCountry,
      entity: userSelectedEntity,
      language: userLanguage,
    }),
    getPrivacyCenterEndpointsRemote({
      accountType: userAccountType,
      country: userCountry,
      entity: userSelectedEntity,
    }),
  ])

  return { privacyCenterComponents, privacyCenterEndpoints }
}

const getPrivacyCenterFromLocal = async ({
  userAccountType,
  userCountry,
  userSelectedEntity,
  userLanguage,
}: {
  userAccountType: TUserType
  userCountry: TCountry
  userSelectedEntity: TEntity
  userLanguage: TLanguage
}) => {
  const [privacyCenterComponents, privacyCenterEndpoints] = await Promise.all([
    getPrivacyCenterComponentsFromLocal({
      accountType: userAccountType,
      country: userCountry,
      entity: userSelectedEntity,
      language: userLanguage,
    }),
    getPrivacyCenterEndpointsRemote({
      accountType: userAccountType,
      country: userCountry,
      entity: userSelectedEntity,
    }),
  ])

  return { privacyCenterComponents, privacyCenterEndpoints }
}

export { getPrivacyCenter, getPrivacyCenterFromLocal }
